export default "__VITE_ASSET__Cq_I3Tq1__"